/*
 * wiwify-login-redirect.js
 * layout/theme.liquid → </body> öncesi (koşulsuz)
 *
 * Amaç: Mağazadaki TÜM giriş (login) bağlantıları, kullanıcı giriş yaptıktan
 * sonra Wiwify Circle sayfasına dönsün. Yeni müşteri hesaplarında bunun resmi
 * yolu /customer_authentication/login?return_to=<göreli-url> parametresidir
 * (Shopify: "Customer sign-in links and redirects"). return_to yalnızca göreli
 * URL ile çalışır.
 *
 * Kapsam:
 *   - Header hesap çekmecesi giriş linki (storefront_login_url)
 *   - Sepet "giriş yap" CTA'sı (account_login_url)
 *   - Appstle loyalty cart widget'ının "Giriş Yap" linki (geç enjekte edilir)
 *   - İleride eklenecek her türlü /account/login | /customer_authentication/login linki
 *
 * Teknik: hem href'leri yeniden yazar (cart-drawer forwarding'i href'i okuduğu
 * için şart) hem de capture aşamasında tıklamayı yakalar (henüz yazılmamış
 * linkler için güvenlik ağı). MutationObserver geç gelen linkleri de yakalar.
 */
(function () {
  'use strict';

  var RETURN_TO = '/pages/wiwify-circle';
  var CARRY = ['login_hint', 'locale', 'ui_hint'];

  function isLoginPath(pathname) {
    return /\/account\/login\/?$/.test(pathname) ||
           /\/customer_authentication\/login\/?$/.test(pathname);
  }

  // Bir giriş href'inden, Circle'a dönen yeni bir login URL üretir.
  // Giriş linki değilse veya zaten Circle'a dönüyorsa null döner.
  function buildLoginUrl(href) {
    var u;
    try { u = new URL(href, window.location.origin); } catch (e) { return null; }
    if (!isLoginPath(u.pathname)) return null;
    if (u.searchParams.get('return_to') === RETURN_TO) return null; // zaten doğru → döngüyü önle
    // Sayfa kendi return_to'sunu açıkça vermişse (örn. /pages/wiwify-journey) ona saygı göster —
    // bu script yalnız return_to'su OLMAYAN giriş linklerini Circle'a yönlendirir. (Journey, 2026-09-09)
    if (u.searchParams.get('return_to')) return null;
    var params = new URLSearchParams();
    params.set('return_to', RETURN_TO);
    for (var i = 0; i < CARRY.length; i++) {
      var v = u.searchParams.get(CARRY[i]);
      if (v) params.set(CARRY[i], v);
    }
    return '/customer_authentication/login?' + params.toString();
  }

  function rewriteAnchor(a) {
    var next = buildLoginUrl(a.href);
    if (next) a.setAttribute('href', next);
  }

  function rewriteWithin(root) {
    if (!root || !root.querySelectorAll) return;
    var anchors = root.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) rewriteAnchor(anchors[i]);
  }

  // Güvenlik ağı: link henüz yeniden yazılmadan tıklanırsa yönlendirmeyi yakala.
  document.addEventListener('click', function (event) {
    var t = event.target;
    var a = t && t.closest ? t.closest('a[href]') : null;
    if (!a) return;
    var next = buildLoginUrl(a.href);
    if (next) {
      event.preventDefault();
      window.location.href = next;
    }
  }, true);

  function init() {
    rewriteWithin(document);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('a[href]')) rewriteAnchor(node);
          rewriteWithin(node);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
